let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6ytS7")).then(() => parcelRequire('ij8p1'));